<template>
    <!-- Página completa -->
    <div
        v-if="layout === 'page'"
        class="container weflix-admin-newCupon"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <div v-if="!hideHeading" class="titleContainer">
            <h3>Novo Cupom</h3>
            <p>
                Crie um novo cupom para atrair novos clientes, criar campanhas de
                marketing e estabelecer parcerias.
            </p>
        </div>
        <div class="contetContainerNewPlan">
            <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="col-form-inner col-12 col-md-12 col-lg-12 cupom-field">
                    <div class="form-group">
                        <div class="form-label">
                            <label :for="idPrefix + '-code'"
                                >Código do cupom<v-tooltip
                                    text="Campo obrigatório"
                                    location="top"
                                >
                                    <template v-slot:activator="{ props }">
                                        <fa
                                            v-bind="props"
                                            icon="fa-solid fa-circle-exclamation"
                                        ></fa>
                                    </template> </v-tooltip
                            ></label>
                        </div>
                        <div class="form-input">
                            <input
                                :id="idPrefix + '-code'"
                                type="text"
                                required
                                class="form-control"
                                v-model="code"
                                placeholder="Off10"
                            />
                            <small>Nome comercial de sua coleção, uso externo.</small>
                        </div>
                    </div>
                </div>

                <div class="col-form-inner col-12 col-md-12 col-lg-12 cupom-field">
                    <div class="form-group">
                        <div class="form-label">
                            <label :for="idPrefix + '-discount'"
                                >Desconto do cupom %<v-tooltip
                                    text="Campo obrigatório"
                                    location="top"
                                >
                                    <template v-slot:activator="{ props }">
                                        <fa
                                            v-bind="props"
                                            icon="fa-solid fa-circle-exclamation"
                                        ></fa>
                                    </template> </v-tooltip
                            ></label>
                        </div>
                        <div class="form-input">
                            <input
                                :id="idPrefix + '-discount'"
                                type="text"
                                required
                                class="form-control"
                                v-model="discount"
                                placeholder="10"
                            />
                            <small>Nome comercial de sua coleção, uso externo.</small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="col-form-inner col-12 col-md-12 col-lg-12 cupom-field">
                    <div class="form-group">
                        <div class="form-label">
                            <label :for="idPrefix + '-expired'"
                                >Data de Expiração<v-tooltip
                                    text="Campo obrigatório"
                                    location="top"
                                >
                                    <template v-slot:activator="{ props }">
                                        <fa
                                            v-bind="props"
                                            icon="fa-solid fa-circle-exclamation"
                                        ></fa>
                                    </template> </v-tooltip
                            ></label>
                        </div>
                        <div class="form-input">
                            <input
                                :id="idPrefix + '-expired'"
                                type="date"
                                required
                                class="form-control"
                                v-model="expired"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div class="col-form-inner col-12 col-md-12 col-lg-12"></div>
        </div>
        <div class="actions">
            <v-btn
                variant="outlined"
                border="2"
                color="primary"
                :size="$vuetify.display.xs ? 'default' : 'large'"
                :disabled="saving"
                @click="onCancel"
                >Voltar</v-btn
            >
            <v-btn
                variant="flat"
                border="2"
                color="primary"
                :size="$vuetify.display.xs ? 'default' : 'large'"
                :loading="saving"
                :disabled="saving"
                @click="newCupom"
                >Salvar</v-btn
            >
        </div>
    </div>

    <!-- Modal: mesmo padrão visual de NewPlanForm (row / labeld / inputd / ações) -->
    <div v-else class="new-cupon-form new-cupon-form--modal text-left">
        <div class="d-flex flex-column flex-grow-1">
            <div class="row plan-form-fields">
                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld" :for="idPrefix + '-code'"
                            >Código do cupom<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            :id="idPrefix + '-code'"
                            v-model="code"
                            type="text"
                            required
                            class="inputd mb-1"
                            placeholder="Off10"
                        />
                        <small>Nome comercial de sua coleção, uso externo.</small>
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld" :for="idPrefix + '-discount'"
                            >Desconto do cupom %<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            :id="idPrefix + '-discount'"
                            v-model="discount"
                            type="text"
                            required
                            class="inputd mb-1"
                            placeholder="10"
                        />
                        <small>Nome comercial de sua coleção, uso externo.</small>
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld" :for="idPrefix + '-expired'"
                            >Data de Expiração<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            :id="idPrefix + '-expired'"
                            v-model="expired"
                            type="date"
                            required
                            class="inputd mb-1"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="plan-modal__footer">
            <v-btn
                variant="flat"
                class="plan-modal__button plan-modal__button--cancel"
                :disabled="saving"
                @click="onCancel"
            >
                Cancelar
            </v-btn>
            <v-btn
                variant="flat"
                class="plan-modal__button plan-modal__button--save"
                :loading="saving"
                :disabled="saving"
                @click="newCupom"
            >
                Salvar Cupom
            </v-btn>
        </div>
    </div>
</template>

<script>
    import Cupom from '@/utils/Weflix/cupom';
    import { mapState } from 'vuex';
    import { toast } from 'vue3-toastify';

    export default {
        name: 'NewCuponForm',
        emits: ['success', 'cancel', 'saving-change'],
        props: {
            layout: {
                type: String,
                default: 'page',
                validator: (v) => ['page', 'modal'].includes(v),
            },
            hideHeading: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                saving: false,
                code: '',
                discount: '',
                expired: '',
                selectedPlan: '',
            };
        },
        computed: {
            ...mapState(['token']),
            idPrefix() {
                return this.layout === 'modal' ? 'modal-cupon' : 'page-cupon';
            },
        },
        watch: {
            saving(val) {
                this.$emit('saving-change', val);
            },
        },
        methods: {
            resetForm() {
                this.code = '';
                this.discount = '';
                this.expired = '';
                this.selectedPlan = '';
                this.saving = false;
            },
            onCancel() {
                this.$emit('cancel');
            },
            formatDateToISO(date) {
                const d = new Date(date);
                return d.toISOString();
            },
            async newCupom() {
                const payload = {
                    title: this.code,
                    code: this.code,
                    defaul: 0,
                    status: 1,
                    expired: this.formatDateToISO(this.expired),
                    discount: this.discount,
                    planId: this.selectedPlan,
                };
                this.saving = true;
                try {
                    await Cupom.createNewCupom(this.token, payload);
                    this.$emit('success');
                } catch (error) {
                    this.notify(
                        'Erro ao criar cupom, verifique os dados e tente novamente.',
                        'error'
                    );
                    console.error(error);
                } finally {
                    this.saving = false;
                }
            },
            notify(message, type = 'info') {
                toast(message, {
                    autoClose: 3000,
                    position: 'top-right',
                    theme: 'light',
                    limit: 1,
                    type: type,
                    dangerouslyHTMLString: true,
                });
            },
        },
    };
</script>

<style scoped>
    @import '@/Views/Weflix/Adm/global.css';

    .titleContainer {
        display: block;
        text-align: left;
        padding: 0px 10px;
        border-bottom: 1px solid #e8e8e8;
        margin: 10px;
        padding-bottom: 10px;
    }

    .container {
        max-width: 100%;
        background-color: white;
        padding: 10px 0px;
        padding-bottom: 50px;
    }

    .cupom-field {
        width: 99% !important;
    }

    .contetContainerNewPlan {
        display: flex;
        flex-wrap: wrap;
        padding: 20px;
    }

    hr {
        border-color: #b1b1b1;
        height: 1px;
        width: 100%;
        margin: 10px 10px;
    }

    .actions {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        justify-content: flex-end;
        align-items: center;
        padding: 16px 20px 10px;
    }

    /* Modal: alinhado a NewPlanForm */
    .new-cupon-form--modal {
        height: 100%;
        position: relative;
    }

    @media (max-width: 600px) {
        .weflix-admin-newCupon h3 {
            font-size: 20px;
            margin-bottom: 5px;
        }

        .weflix-admin-newCupon small {
            font-size: 12px;
            color: #666;
        }

        .weflix-admin-newCupon .contetContainerNewPlan {
            padding: 0px 10px;
        }

        .weflix-admin-newCupon .actions {
            padding: 0px 20px;
            justify-content: center;
        }
    }
</style>
